export const OKAY = 200;
export const I_AM_A_TEAPOT = 418;
export const BAD_SERVER = 500;
export const SERVICE_URL = window.config.WEB_API_URL;

export const ROOT_SET_STATE = 'setStoreProperty';
export const ROOT_SOURCED = { root: true };

export const LOOKUP_MODULE = 'lookup';
export const LOOKUP_SET_VISIT_DATA = `${LOOKUP_MODULE}/setVisitData`;
export const LOOKUP_STORE_DATA = `${LOOKUP_MODULE}/lookupStoreData`;

export const SLOTS_MODULE = 'slots';
export const SLOTS_STORE_DATA = `${SLOTS_MODULE}/slotsStoreData`;
export const SLOTS_GET_ALL = `${SLOTS_MODULE}/getSlots`;
export const SLOTS_HOLD_CREATE = `${SLOTS_MODULE}/createSlotHold`;
export const SLOTS_HOLD_DELETE = `${SLOTS_MODULE}/removeSlotHold`;
export const SLOTS_COLUMNS = `${SLOTS_MODULE}/getNumOfColumns`;
export const SLOTS_FILTER = `${SLOTS_MODULE}/filterSlots`;

export const RESERVATION_MODULE = 'reservation';
export const RESERVATION_CREATE = `${RESERVATION_MODULE}/createReservation`;
export const RESERVATION_FIND = `${RESERVATION_MODULE}/findReservation`;
export const RESERVATION_UPDATE = `${RESERVATION_MODULE}/updateReservation`;
export const RESERVATION_DELETE = `${RESERVATION_MODULE}/deleteReservation`;
export const RESERVATION_ELIGIBILITY = `${RESERVATION_MODULE}/checkCustomerEligibility`;

export const RESERVATION_MFA_REQUEST = `${RESERVATION_MODULE}/setMfaRequest`;

export const RESERVATION_VERIFY_MFA_REQUEST = `${RESERVATION_MODULE}/setVerifyMfaRequest`;

export const RESERVATION_FIND_CONTACT = `${RESERVATION_MODULE}/getReservationContact`;

export const PAYMENT_MODULE = 'payment';
export const PAYMENT_STORE_DATA = `${PAYMENT_MODULE}/paymentStoreData`;
export const PAYMENT_GET_FEES = `${PAYMENT_MODULE}/getFees`;
export const PAYMENT_PAY = `${PAYMENT_MODULE}/pay`;
export const PAYMENT_SET_FORTE_RESPONSE = `${PAYMENT_MODULE}/setForteResponse`;
